import styled from 'styled-components';

export const TreeItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
